import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import SmallButton from '../SmallButton';
import type { IHeaderGroupParams } from 'ag-grid-community';
import type { ReactNode } from 'react';
import type { AgGridRowData } from './types';

interface AgGridGroupHeaderParams extends IHeaderGroupParams<AgGridRowData> {
  gpicon?: ReactNode;
}

const AgGridGroupHeader = (props: AgGridGroupHeaderParams) => {
  const [expandState, setExpandState] = useState('collapsed');
  const expandOrCollapse = () => {
    let currentState = props.columnGroup.getProvidedColumnGroup().isExpanded();
    props.setExpanded(!currentState);
  };

  const syncExpandButtons = () => {
    setExpandState(
      props.columnGroup.getProvidedColumnGroup().isExpanded()
        ? 'expanded'
        : 'collapsed'
    );
  };

  useEffect(() => {
    props.columnGroup
      .getProvidedColumnGroup()
      .addEventListener('expandedChanged', syncExpandButtons);
    syncExpandButtons();

    return () => {
      props.columnGroup
        .getProvidedColumnGroup()
        .removeEventListener('expandedChanged', syncExpandButtons);
    };
  }, []);
  return (
    <div className="ag-header-group-cell-label">
      <div className="customHeaderLabel d-flex align-items-center gap-2">
        <span style={{ marginTop: '-5px' }}>{props.gpicon}</span>
        {props.displayName}
      </div>
      {props.columnGroup.getProvidedColumnGroup().isExpandable() && (
        <div id="GroupHandler" className={`customExpandButton ${expandState}`}>
          <span className="d-flex ms-1">
            <SmallButton
              style={{
                height: 15,
                width: 15,
                padding: 0,
                borderRadius: '50%'
              }}
              onClick={() => expandOrCollapse()}
            >
              {expandState === 'collapsed' ? (
                <FontAwesomeIcon fontSize="14px" icon="caret-left" />
              ) : (
                <FontAwesomeIcon fontSize="14px" icon="caret-right" />
              )}
            </SmallButton>
          </span>
        </div>
      )}
    </div>
  );
};
export default AgGridGroupHeader;
